export default __webpack_public_path__ + "static/media/pixels-project-3.0a94bff8.webp";